var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetrofit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4996 6.5C21.4996 8.43 19.9296 10 17.9996 10C17.5896 10 17.1996 9.92 16.8396 9.79L5.45961 21.16L3.33961 19.04L10.7496 11.63L8.96961 9.85L8.25961 10.56L6.84961 9.15V11.98L6.13961 12.69L2.59961 9.15L3.30961 8.44H6.12961L4.71961 7.03L8.25961 3.49C9.42961 2.32 11.3296 2.32 12.4996 3.49L10.3796 5.61L11.7896 7.02L11.0796 7.73L12.8596 9.51L14.7096 7.66C14.5796 7.3 14.4996 6.91 14.4996 6.5C14.4996 4.57 16.0696 3 17.9996 3C18.5796 3 19.1196 3.16 19.5996 3.41L16.8996 6.11L18.3896 7.6L21.0896 4.9C21.3396 5.38 21.4996 5.92 21.4996 6.5ZM14.2822 15.1719L16.4035 13.0506L22.3997 19.0468L20.2784 21.1681L14.2822 15.1719Z",
    fill: "#C9D1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4996 6.5C21.4996 8.43 19.9296 10 17.9996 10C17.5896 10 17.1996 9.92 16.8396 9.79L5.45961 21.16L3.33961 19.04L10.7496 11.63L8.96961 9.85L8.25961 10.56L6.84961 9.15V11.98L6.13961 12.69L2.59961 9.15L3.30961 8.44H6.12961L4.71961 7.03L8.25961 3.49C9.42961 2.32 11.3296 2.32 12.4996 3.49L10.3796 5.61L11.7896 7.02L11.0796 7.73L12.8596 9.51L14.7096 7.66C14.5796 7.3 14.4996 6.91 14.4996 6.5C14.4996 4.57 16.0696 3 17.9996 3C18.5796 3 19.1196 3.16 19.5996 3.41L16.8996 6.11L18.3896 7.6L21.0896 4.9C21.3396 5.38 21.4996 5.92 21.4996 6.5ZM14.2822 15.1719L16.4035 13.0506L22.3997 19.0468L20.2784 21.1681L14.2822 15.1719Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetrofit);
export default __webpack_public_path__ + "static/media/Retrofit.0db69c207a4ebfc30db1937549b1a261.svg";
export { ForwardRef as ReactComponent };